//=======================| App Configuration |========================//
export default {
	appLogo: '/static/images/logo.png', 
	appLogoDark: '/static/images/logo-dark.png',                         // App Logo,
	brand: 'Embryo',                                        		   // Brand Name
	copyrightText: '© All Rights Reversed | Made With Love by IRON NETWORK for better Web',     // Copyright Text
	//theme color
	color: {
      primary: '#D9582E',
      accent : '#D9582E',
	},
	algoliaApiKey: '6be0576ff61c053d5f9a3225e2a90f76'
}
